import {gql} from "@apollo/client";

export const RESTORE_ACCESS = gql`
    mutation RestoreAccess($newPassword: String!,$token: String!) {
        restoreAccess(newPassword: $newPassword, token: $token)
    }
`;
